import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  baseUrl = environment.mongoApiUrl;
  DocsUrl = environment.docUrl;

  constructor(private httpclient: HttpClient) {}
  // getProfile(): Observable<CandidateDetails> {
  //   return this.httpclient.get<CandidateDetails>('assets/jsons/profile.json')
  // }

  public getFileIds(objectId, objectType, attachmentId) {
    return this.httpclient.get<any>(this.baseUrl + 'getFileId/' + objectId + '/' + objectType + '/' + attachmentId);
  }
  public getpercentage(appID) {
    return this.httpclient.get<any>(this.DocsUrl + 'profileService/percentage' + '/' + appID);
  }

  public getProfileHistory(canId) {
    const pfHistoryUrl = this.baseUrl.split('file')[0];
    const requestOptions: object = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.get<any>(
      pfHistoryUrl + 'RecruiterModule/getCandidateProfileHistory/' + canId + '/CD',
      requestOptions,
    );
  }

  public downloadFile(fileID) {
    return this.httpclient.get<any>(this.baseUrl + 'downloadFileNew?id=' + fileID);
  }
  public downLoadFileData(fileData, fileOutputName?) {
    let _mimeType = '';
    let typeFile = '';
    if (!fileData.fileType.startsWith('.')) {
      typeFile = '.' + fileData.fileType;
    } else {
      typeFile = fileData.fileType;
    }
    switch (typeFile) {
      case '.pdf': {
        _mimeType = 'pdf';
        break;
      }
      case '.docx': {
        _mimeType = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      }
      case '.doc': {
        _mimeType = 'msword';
        break;
      }
      case '.jpg': {
        _mimeType = 'jpeg';
        break;
      }
      case '.jpeg': {
        _mimeType = 'jpeg';
        break;
      }
      case '.png': {
        _mimeType = 'png';
      }
    }

    const fileName = fileOutputName || fileData.fileName + '' + typeFile;

    const arrBuffer = this.base64ToArrayBuffer(fileData.file.data);

    const newBlob = new Blob([arrBuffer], { type: 'application/pdf' });
    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = data;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(data);
    link.remove();
  }

  base64ToArrayBuffer(data) {
    const binaryString = window.atob(data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
}
